import type { BudgetRecordType } from "~/models";

const budgetTypes: BudgetRecordType[] = [
    {
        id: "1",
        name: "Fee",
    },
    {
        id: "2",
        name: "Purchase",
    },
    {
        id: "3",
        name: "Other",
    },
];

export default budgetTypes;
